import { Heading } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Icon } from "@mittwald/flow-remote-react-components";
import { IconUser } from "@mittwald/flow-remote-react-components";
import { IllustratedMessage } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { ModalTrigger } from "@mittwald/flow-remote-react-components";
import CreateUserModal from "./CreateUserModal";

export const NoUsers = (props: {
  projectId: string;
  /** Opens an externally rendered CreateUserModal instead of an own one. */
  onCreateUser?: () => void;
}) => {
  return (
    <IllustratedMessage>
      <Icon>
        <IconUser />
      </Icon>
      <Heading>Kein Benutzer angelegt</Heading>
      <Text>
        Lege deinen ersten Benutzer an, um ihn in einem Passwortschutz zu
        verwenden.
      </Text>
      {props.onCreateUser ? (
        <Button color="success" onPress={props.onCreateUser}>
          Benutzer anlegen
        </Button>
      ) : (
        <ModalTrigger>
          <Button color="success">Benutzer anlegen</Button>
          <CreateUserModal projectId={props.projectId} />
        </ModalTrigger>
      )}
    </IllustratedMessage>
  );
};
